import React from "react";
import "./About.css";
import hadid from "../../image/hadid1.jpg";
import Fade from "react-reveal/Fade";
const About = () => {
  return (
    <div className="about" id="About">
      <h1 className="title">About</h1>
      <div className="about-container d-flex align-items-center">
        <div className="col-md-5 ml-3 col_left">
          <Fade right>
            <img
              style={{ height: "400px", width: "400px", borderRadius: "10px" }}
              src={hadid}
              alt=""
            />
          </Fade>
        </div>
        <div className="col-md-6 col_right">
          <Fade left>
            <div className="right-title">
              I'm Hadid and I'm a <span>Developer</span>
            </div>
            <p>
              Full Stack Developer with 1 years of hands-on experience
              designing, developing, and implementing applications and solutions
              using a range of technologies and programming languages. Seeking
              to leverage broad development experience and hands-on technical
              expertise in a challenging role as a Full-stack Developer.
            </p>
            <a
              target="blank"
              href="https://drive.google.com/file/d/1qFT57B2T2gqBgLlVU5JgG8DYwLXEXa1j/view?usp=sharing"
              className="cv-btn"
            >
              Download CV
            </a>
          </Fade>
        </div>
      </div>
    </div>
  );
};

export default About;
